
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LayoutItemProps } from ".";
import { loading, create } from "store/layout";
import { AppMessage } from "components";

interface ApiLayoutCreateInputProps extends Omit<LayoutItemProps, "id"> {
}

type ApiLayoutCreateOutputProps = OutputBaseProps<{ item: LayoutItemProps; }, ApiLayoutCreateInputProps>

export const apiLayoutCreate = async (data: ApiLayoutCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiLayoutCreateOutputProps>("/api/layout/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};